import { useLocale } from "next-intl";
import { useRouter } from "@/i18n/routing";
import { signInWithSocial } from "@/api/authNew";
import { getAuthRedirectPath } from "@/utils/navigation";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { publishSessionLogin } from "@/utils/sessionLogin";

export function useSocialSignIn() {
  const router = useRouter();
  const locale = useLocale();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: signInWithSocial,
    onSuccess(auth) {
      queryClient.clear();
      // Sibling tabs parked on sign-in pick the new session up right away.
      publishSessionLogin({ now: new Date() });
      const entryPath = getAuthRedirectPath(auth);
      router.replace(entryPath, { locale });
      router.refresh();
    },
  });
}
